/*
 * Copyright (c) 2016 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */
import { Component, ElementRef, EventEmitter, HostListener, Input, Optional, Output, SkipSelf } from "@angular/core";
import { Point } from "../common/popover";
import { menuPositions } from "./menu-positions";
// TODO: the ng-content inside the ng-template should ideally just be
// <ng-content select="clr-dropdown-menu"></ng-content>. Remove .dropdown-menu in 1.0?
var Dropdown = (function () {
    function Dropdown(elementRef, parent) {
        this.elementRef = elementRef;
        this.parent = parent;
        this._open = false;
        this._openChanged = new EventEmitter(false);
        this.isMenuClosable = true;
        this.anchorPoint = Point.BOTTOM_LEFT; // default if menuPosition isn't set
        this.popoverPoint = Point.LEFT_TOP; // default if menuPosition isn't set
        this.popoverOptions = { allowMultipleOpen: true };
        this.anchor = elementRef.nativeElement;
    }
    Object.defineProperty(Dropdown.prototype, "isRootLevelDropdown", {
        get: function () {
            return this.parent === null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Dropdown.prototype, "menuPosition", {
        get: function () {
            return this._menuPosition;
        },
        set: function (pos) {
            if (pos && (menuPositions.indexOf(pos) > -1)) {
                this._menuPosition = pos;
            }
            else {
                this._menuPosition = "bottom-left";
            }
            // set the popover values based on menu position
            switch (this._menuPosition) {
                case ("top-right"):
                    this.anchorPoint = Point.TOP_RIGHT;
                    this.popoverPoint = Point.RIGHT_BOTTOM;
                    break;
                case ("top-left"):
                    this.anchorPoint = Point.TOP_LEFT;
                    this.popoverPoint = Point.LEFT_BOTTOM;
                    break;
                case ("bottom-right"):
                    this.anchorPoint = Point.BOTTOM_RIGHT;
                    this.popoverPoint = Point.RIGHT_TOP;
                    break;
                case ("bottom-left"):
                    this.anchorPoint = Point.BOTTOM_LEFT;
                    this.popoverPoint = Point.LEFT_TOP;
                    break;
                case ("right-top"):
                    this.anchorPoint = Point.RIGHT_TOP;
                    this.popoverPoint = Point.LEFT_TOP;
                    break;
                case ("right-bottom"):
                    this.anchorPoint = Point.RIGHT_BOTTOM;
                    this.popoverPoint = Point.LEFT_BOTTOM;
                    break;
                case ("left-top"):
                    this.anchorPoint = Point.LEFT_TOP;
                    this.popoverPoint = Point.RIGHT_TOP;
                    break;
                case ("left-bottom"):
                    this.anchorPoint = Point.LEFT_BOTTOM;
                    this.popoverPoint = Point.RIGHT_BOTTOM;
                    break;
                default:
                    this.anchorPoint = Point.BOTTOM_LEFT;
                    this.popoverPoint = Point.LEFT_TOP;
                    break;
            }
        },
        enumerable: true,
        configurable: true
    });
    Dropdown.prototype.toggleDropdown = function () {
        this.open = !this.open;
    };
    Object.defineProperty(Dropdown.prototype, "open", {
        get: function () {
            return this._open;
        },
        set: function (val) {
            this._open = val;
            this._openChanged.emit(val);
        },
        enumerable: true,
        configurable: true
    });
    //called on mouse clicks anywhere in the DOM.
    //Checks to see if the mouseclick happened on the host or outside
    Dropdown.prototype.onMouseClick = function (target) {
        if (this.open) {
            var current = target; //Get the element in the DOM on which the mouse was clicked
            var dropdownHost = this.elementRef.nativeElement; //Get the current dropdown native HTML element
            //Start checking if current and dropdownHost are equal. If not traverse to the parentNode and check again.
            while (current) {
                if (current === dropdownHost) {
                    return;
                }
                current = current.parentNode;
            }
            this.open = false; //Remove .open from the dropdown
        }
    };
    return Dropdown;
}());
export { Dropdown };
Dropdown.decorators = [
    { type: Component, args: [{
                selector: "clr-dropdown",
                template: "\n        <ng-content select=\"[clrDropdownToggle]\"></ng-content>\n        <ng-template [(clrPopover)]=\"open\" [clrPopoverAnchor]=\"anchor\" [clrPopoverAnchorPoint]=\"anchorPoint\"\n                     [clrPopoverPopoverPoint]=\"popoverPoint\" [clrPopoverOptions]=\"popoverOptions\">\n            <ng-content select=\"[clr-dropdown-menu, .dropdown-menu]\"></ng-content>\n        </ng-template>\n    ",
                host: {
                    "[class.dropdown]": "true",
                    "[class.right-top]": "menuPosition == 'right-top'",
                    "[class.left-top]": "menuPosition == 'left-top'",
                    "[class.right-bottom]": "menuPosition == 'right-bottom'",
                    "[class.left-bottom]": "menuPosition == 'left-bottom'",
                    "[class.open]": "true" // always set to true; clrPopover will remove it from DOM when not open
                }
            },] },
];
/** @nocollapse */
Dropdown.ctorParameters = function () { return [
    { type: ElementRef, },
    { type: Dropdown, decorators: [{ type: SkipSelf }, { type: Optional },] },
]; };
Dropdown.propDecorators = {
    '_open': [{ type: Input, args: ["clrDropdownMenuOpen",] },],
    '_openChanged': [{ type: Output, args: ["clrDropdownMenuOpenChange",] },],
    'isMenuClosable': [{ type: Input, args: ["clrCloseMenuOnItemClick",] },],
    'menuPosition': [{ type: Input, args: ["clrMenuPosition",] },],
    'onMouseClick': [{ type: HostListener, args: ["document:click", ["$event.target"],] },],
};
//# sourceMappingURL=dropdown.js.map


//////////////////
// WEBPACK FOOTER
// ./~/clarity-angular/popover/dropdown/dropdown.js
// module id = 61
// module chunks = 4